/***
 * Theme switch.
 * */

const themeSwitch = document.querySelector('[data-theme-switch]');
const storageKey = 'theme';

/**
 * Set the theme for the current page.
 * @param {string} theme 'dark' | 'light'
 */
const setTheme = theme => {
    document.documentElement.setAttribute('data-theme', theme);
    if (themeSwitch) {
        const nextState = theme == 'light' ? 'true' : 'false';
        themeSwitch.setAttribute('aria-pressed', nextState);
    }
};

/**
 * Set the theme and save it for future page views.
 * @param {string} theme 'dark' | 'light'
 */
const setAndSaveTheme = theme => {
    setTheme(theme);
    window.localStorage.setItem(storageKey, theme);
};

// Restore saved theme, then flush the layout to prevent the initial transition
const darkThemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
const currentTheme =
    window.localStorage.getItem(storageKey) || (darkThemeQuery.matches ? 'dark' : 'light');
setTheme(currentTheme);
themeSwitch.offsetHeight;
themeSwitch.classList.add('theme-switch--initialized');

darkThemeQuery.addEventListener('change', e => setAndSaveTheme(e.matches ? 'dark' : 'light'));

if (themeSwitch) {
    themeSwitch.addEventListener('click', e => {
        const nextTheme =
            e.currentTarget.getAttribute('aria-pressed') === 'false' ? 'light' : 'dark';
        setAndSaveTheme(nextTheme);
    });
}

/***
 * Language select.
 * */

const languageSelect = document.querySelectorAll('[data-language-switch]');
languageSelect.forEach(select => {
    select.addEventListener('change', () => {
        location.href = select.value;
    });
});

/***
 * Logo scroll animation.
 * */

const navigation = document.getElementById('site-navigation');
const navigationCollapsedClass = 'navigation--collapsed';

window.addEventListener(
    'scroll',
    e => {
        if (window.scrollY > 50) {
            navigation.classList.add(navigationCollapsedClass);
        } else {
            navigation.classList.remove(navigationCollapsedClass);
        }
    },
    { passive: true },
);

/***
 * Menu.
 * */

const toggleButton = document.getElementById('site-navigation-button');

const navigationActiveClassName = 'navigation--active';
const toggleButtonActiveClassName = 'menu-toggle--active';

const showNavigation = () => {
    navigation.classList.add(navigationActiveClassName);
    toggleButton.classList.add(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'true');
};

const hideNavigation = () => {
    navigation.classList.remove(navigationActiveClassName);
    toggleButton.classList.remove(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'false');
};

if (navigation && toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        isActive ? hideNavigation() : showNavigation();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            hideNavigation();
        }
    });
}
